import CryptoJS from 'crypto-js';

const SECRET_KEY = 'FABDROID@2025';

export default class ServiceUtil {
    saveEncrypted = (key, data) => {
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
        sessionStorage.setItem(key, encrypted);
    };

    getDecrypted = (key) => {
        const encrypted = sessionStorage.getItem(key);
        if (!encrypted) return null;
        const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    };
}